import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const PortfolioSizePage = lazy(() => import('./PortfolioSizePage'));

const path = 'reports/domain-count/count';
const PortfolioSizeRoute: FuseRouteItemType = {
	path: path,
	element: <PortfolioSizePage />,
	settings: {
		layout: {
			config: {
				navbar: {
					display: true
				},
				toolbar: {
					title: 'Portfolio Size',
					helpName: 'Domain Count',
					showTitle: false,
					showCrumbs: false,
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	}
};

export default PortfolioSizeRoute;
